import React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import styles from '../EkgRecordingReviewScreen.css'
import FormattedDate from '../../../components/FormattedDate'
import SuccessIcon from 'static/images/success.svg'
import { getPhysicianName } from '../../../containers/Utilities'

export const Confirmed = props => {
  const {
    confirmation: {
      createdAt,
      firstName,
      lastName,
    },
    me,
  } = props

  return (
    <div className={styles.confirmed}>
      <div className={styles.confirmedIcon}>
        <SuccessIcon />
      </div>
      <div className={styles.confirmedBy}>
        <FormattedHTMLMessage
          id="confirmation.Confirmed_by"
          values={{
            physicianName: getPhysicianName(firstName, lastName)
          }}
        />
      </div>
      <div className={styles.date}>
        <FormattedDate date={createdAt} me={me} />
      </div>
    </div>
  )
}

export default Confirmed



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/Confirmed.jsx